import { create } from "zustand";

interface SalesPageState {
  salesTimer: number;
  salesExpire: boolean;
  setSalesTimer: (newSalesTimer: number) => void;
  setSalesExpire: (newSalesExpire: boolean) => void;
}

interface FullScreenModalState {
  isOpen: boolean;
  setIsOpen: (val: boolean) => void;
}

interface FallBackGooglePayState {
  fallbackGooglePay: boolean;
  setFallbackGooglePay: (val: boolean) => void;
}

export const useStore = create<SalesPageState>((set) => ({
  salesTimer: 0,
  salesExpire: true,
  setSalesTimer: (newSalesTimer) => set(() => ({ salesTimer: newSalesTimer })),
  setSalesExpire: (newSalesExpire) =>
    set(() => ({ salesExpire: newSalesExpire })),
}));

export const useFullScreenModalStore = create<FullScreenModalState>((set) => ({
  isOpen: false,
  setIsOpen: (val: boolean) => set({ isOpen: val }),
}));

export const useFallbackGooglePayStore = create<FallBackGooglePayState>(
  (set) => ({
    fallbackGooglePay: false,
    setFallbackGooglePay: (val: boolean) => set({ fallbackGooglePay: val }),
  }),
);
